// extracted by mini-css-extract-plugin
export default {"self":"style_self__Y7bmw","add":"style_add__YEyOq","delete":"style_delete__zVm4p"};